import { CookiesStorage } from '@/storage/cookies';

const REPORT_TYPES: { [key: string]: string } = {
  detailed_person_report: 'person',
  property_report: 'property',
  social_network_report: 'email',
  reverse_phone_report: 'phone',
  sex_offender_report: 'neighborhood',
  username_report: 'username',
  vehicle_search: 'vehicle',
  username_search: 'username',
  contact_report: 'contact',
  obituary_report: 'obituary',
  unclaimed_money_search: 'unclaimed_money',
};

const MISC_SEARCH_TYPES: { [key: string]: string } = {
  language_chat: 'language_chat',
  personality_test: 'personality_test',
  astrology: 'astrology',
};

const SEARCH_TYPES: { [key: string]: string } = {
  ...REPORT_TYPES,
  ...MISC_SEARCH_TYPES,
};

const LISTING_TYPES: { [key: string]: string } = {
  listings: 'for_sale',
  pfc: 'pre_foreclosures',
};

type FirstRecordSearchRaw = {
  person_id: string;
  phone_number: string;
  email: string;
  address: string;
  vin: string;
  license_plate: string;
  year: string;
  make: string;
  model: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  state: string;
  city: string;
  age: string;
  zip_code: string;
  company: string;
  job: string;
  name: string;
  seniority: string;
  industry: string;
  search_type: string;
  record_search_set: boolean;
  username: string;
  flow_search_type: string;
  dob: string;
  dod: string;
  native_language: string;
  learning_language: string;
  learning_language_level: string;
  learning_language_topic: string;
  personality_test_results: { [question: string]: string };
  astrology_input: string;
};

export type FirstRecordSearch = Omit<
  FirstRecordSearchRaw,
  'record_search_set' | 'search_type'
> & {
  searchType: string;
};

export function getFirstRecordSearch() {
  const cookieStorage = new CookiesStorage();
  const firstRecordSearch = cookieStorage.getValue('first_record_search') || '';
  let data: FirstRecordSearchRaw;

  try {
    data = JSON.parse(firstRecordSearch);
  } catch {
    return null;
  }

  const { search_type, record_search_set, ...rest } = data;
  const hasValidData =
    data.person_id ||
    data.phone_number ||
    data.email ||
    data.address ||
    data.vin ||
    (data.license_plate && data.state) ||
    (data.year && data.make && data.model) ||
    (data.first_name && data.last_name) ||
    (data.state && data.city) ||
    data.zip_code ||
    data.company ||
    data.job ||
    data.name ||
    data.state ||
    data.seniority ||
    data.industry ||
    data.username ||
    data.search_type === 'language_chat' ||
    data.search_type === 'personality_test' ||
    data.search_type === 'astrology';

  if (hasValidData && search_type && record_search_set) {
    return {
      searchType:
        data.search_type === 'listings_pfc_search'
          ? LISTING_TYPES[data.flow_search_type] || 'for_sale'
          : SEARCH_TYPES[data.search_type],
      ...rest,
    };
  }
  return null;
}
